var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-readonly-field"},[_c('div',{staticClass:"ui-readonly-field__label body-1 mb-1 d-flex align-center"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.labelText))]})],2),_c('div',{staticClass:"ui-readonly-field__value subtitle-2 text-break"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.displayValue))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }